import React from 'react'

export function UiFullLoadingSpinner(props) {

    return (
        <>
        {props.fullLoading &&
            <div className='sb-loading-wr'>
                <div className="loader"></div>
            </div>
        }
        </>
    )
}
